import React, { Component } from "react";
import { backendGet } from "../../../helpers/callBackend";
import { ArrowRightOutlined } from "@ant-design/icons";
import { downloadPDF } from "../../../helpers/downloadPDF";

class UnitVerificationDoc extends Component {
    constructor(props) {
        super(props);
        this.state = {
            verificationDoc: [],
        };
    }

    downloadVerificationPDF = () => {
        backendGet(
            this,
            "/api/bank-account/verification-document",
            { params: { bank_account_id: this.props.bankAccountId } },
            "loading",
            (s, d) => {
                downloadPDF(d, `verification-document-${this.props.bankAccountInfo.account_description.toLowerCase().replace(/ /g, '-')}.pdf`);
                return s;
            }
        );
    };

    render() {
        return (
            <>
                {this.props.bankAccountSource === 'UN' &&
                    <a
                        onClick={() => this.downloadVerificationPDF()}
                        style={{ fontWeight: "400", fontSize: "14px" }}>
                        Verification Document <ArrowRightOutlined />
                    </a>
                }
            </>
        );
    }
}

export default UnitVerificationDoc;
